import { ExInput } from '@boomi/exosphere';
import styles from '../../shared/Form.module.css';

export interface FormValues {
    name: string;
    allowedAudience: string;
    clientId: string;
    clientSecret: string;
    wellKnownUrl: string;
}

export const EMPTY_FORM_VALUES: FormValues = {
    name: '',
    allowedAudience: '',
    clientId: '',
    clientSecret: '',
    wellKnownUrl: '',
};

interface IdentityProviderFormFieldsProps {
    values: FormValues;
    onChange: (patch: Partial<FormValues>) => void;
}

const IdentityProviderFormFields = ({ values, onChange }: IdentityProviderFormFieldsProps) => (
    <div className={styles.fields}>
        <ExInput
            label="Name"
            type="text"
            value={values.name}
            onInput={(e) => onChange({ name: (e.target as HTMLInputElement).value })}
            placeholder="e.g. Okta"
            required
        />

        <ExInput
            label="Allowed Audience"
            type="text"
            value={values.allowedAudience}
            onInput={(e) => onChange({ allowedAudience: (e.target as HTMLInputElement).value })}
            placeholder="e.g. https://your-domain.okta.com"
            helpText="The audience value expected in incoming tokens from this provider."
            required
        />

        <ExInput
            label="Well-Known URL"
            type="url"
            value={values.wellKnownUrl}
            onInput={(e) => onChange({ wellKnownUrl: (e.target as HTMLInputElement).value })}
            placeholder="https://your-domain.okta.com/.well-known/openid-configuration"
            helpText="The OpenID Connect discovery document URL for this provider."
            required
        />

        <ExInput
            label="Client ID"
            type="text"
            value={values.clientId}
            onInput={(e) => onChange({ clientId: (e.target as HTMLInputElement).value })}
            required
        />

        <ExInput
            label="Client Secret"
            type="password"
            togglePassword
            value={values.clientSecret}
            onInput={(e) => onChange({ clientSecret: (e.target as HTMLInputElement).value })}
            required
        />
    </div>
);

export default IdentityProviderFormFields;
